import React from 'react'
import CustomDeleteDialog from 'core/components/CustomDeleteDialog'
import { removeServerGroupVirtualMachine } from './actions'

const RemoveServerGroupDialog = (props) => {
  return (
    <CustomDeleteDialog
      {...props}
      deleteAction={removeServerGroupVirtualMachine}
      title="Remove Server Group(s)"
      subTitle="You are about to remove server group from the selected VM(s)."
      onClose={props.onClose}
      actionNames={{
        inProgress: 'Removing',
        success: 'Removed',
        failed: 'Failed to remove',
      }}
      buildBodyFn={(vm) => ({
        removeFromServerGroup: { group_id: vm?.serverGroup?.id },
      })}
    />
  )
}

export default RemoveServerGroupDialog
